import { useSuspenseQuery } from '@tanstack/react-query';
import { useMMKVString } from 'react-native-mmkv';

import { storage, storageKeys } from '@/constants/storage';

import { useHasSession } from '../auth/useHasSession';
import { customerQueryOptions } from '../queries/customer/useCustomerQuery';

/**
 * Suspends on the customer request itself, so the boundary retries once it
 * settles, including after useCustomerQuery repairs a forbidden id.
 */
export const useCustomerOrThrow = () => {
  const [customerId] = useMMKVString(storageKeys.customerId, storage);
  const hasSession = useHasSession();
  if (!customerId || !hasSession) {
    throw new Error('Only use this hook in signed in screens');
  }

  const { data } = useSuspenseQuery(customerQueryOptions(customerId));
  return data;
};
